import React, { useState } from "react";
import { Affix, Nav } from "@alifd/next";
import MaterialList from "../MaterialList";
import styles from "./index.module.scss";

function MatterNav(props) {
  const {
    currentMatter,
    dataSource,
    onChange,
    sequenceNo,
    showMaterialList,
  } = props;

  const onSelect = (keys, item, extra) => {
    onChange(extra?.key);
  };

  return (
    <>
      <div className={styles.material}>
        <MaterialList
          sequenceNo={sequenceNo}
          showMaterialList={showMaterialList}
        />
      </div>
      <Affix className={styles.nav} useAbsolute>
        <Nav
          direction="hoz"
          type="normal"
          selectedKeys={[currentMatter]}
          onSelect={onSelect}
          activeDirection="top"
        >
          {dataSource.map((item, index) => {
            return <Nav.Item key={item.matterId}>{item.matterName}</Nav.Item>;
          })}
        </Nav>
      </Affix>
    </>
  );
}

export default MatterNav;
